import { v1ApiClient } from '@/services';

export const toggleStarChart = async (
  alias: string,
  starred: boolean,
) => {
  const res = await v1ApiClient.patch(`/charts/${alias}/starred`, { starred });
  return res.data;
};
